module.exports = __webpack_public_path__ + "static/media/no-icon.a4987f9b.svg";